
import { GeneralInfo } from "./Sections/GeneralInfo";
import { CommercialTerms } from "./Sections/CommercialTerms";
import { Header } from "./Sections/Header";
import { TradeSupport } from "./Sections/TradeSupport";
import { Document } from "./Sections/Document";
import { BasicInfo } from "./Sections/BasicData";
import { Declaration } from "./Sections/Declaration";
import { ZAEXBasicInfo } from "./ZAEXSections/BasicData";
import { ZAEXCommercialTerms } from "./ZAEXSections/CommercialTerms";

export const generateVendorHTML = (res) => {
  const data = res.Data;

  return `
<html>
<head>
<style>
  body {
    font-family: Arial;
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 15px;
    page-break-inside: auto;
  }

  tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  td, th {
    border: 0.2px solid #333;
    padding: 6px;
    vertical-align: top;
    word-break: break-word;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  td div, th div {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  h3 {
    margin-top: 20px;
    page-break-after: avoid;
    break-after: avoid;
  }

  h5 {
    page-break-after: avoid;
    break-after: avoid;
    margin-top: 16px;
    margin-bottom: 6px;
  }

  /* Keeps h5 heading pinned to the top of its table */
  .section {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .page-break {
    page-break-before: always;
    break-before: page;
  }

  @media print {
    .footer-sign {
      position: fixed;
      bottom: 20px;
      left: 0;
      right: 0;
      width: 100%;
      padding: 0 20px;
      font-size: 12px;
      background: white;
      z-index: 1000;
    }
  }

  .footer-sign .date {
    float: left;
    font-weight: 600;
  }

  .footer-sign .signature {
    float: right;
    font-weight: 600;
    text-align: right;
  }

  @page {
    margin-top: 60px;      /* ← added: prevents headings clipping at top of page */
    margin-bottom: 140px;
  }

  .signature-img {
    width: 120px;
    height: auto;
    object-fit: contain;
  }
</style>
</head>
<body>
  ${Header(data?.Vendor)}

  <div class="section">${GeneralInfo(data?.GeneralInformation)}</div>

  <div class="section">
    ${data?.GeneralInformation.VendorType == "ZAEX"
      ? ZAEXBasicInfo(data?.BasicData)
      : BasicInfo(data?.BasicData)}
  </div>

  <div class="section">
    ${data?.GeneralInformation.VendorType == "ZAEX"
      ? ZAEXCommercialTerms(data.BasicData?.VendorCommercialTermsDto[0])
      : CommercialTerms(data.BasicData?.VendorCommercialTermsDto[0])}
  </div>

  ${data?.GeneralInformation.VendorType !== "ZAEX"
    ? `<div class="section">${TradeSupport(data.BasicData?.TradeSupportTermsDto[0])}</div>`
    : ""}

  <div class="section">${Document(data?.BasicData?.VendorDocumentsDto[0])}</div>

  ${Declaration()}
</body>
</html>
`;
};